import { handleActions, Action } from 'redux-actions';

// Actions
import { removeRecruiterCandidate } from 'modules/JobBoard/actions';
import {
  setAllJobPosts,
  setUserJobPosts,
  setJobPost,
  setJobPostsLoading,
  saveRecruiterJobPost,
  deleteRecruiterJobPost,
} from './actions';

const jobPostsInitialState = {
  userJobPosts: [] as any[],
  allJobPosts: [] as any[],
  loading: false,
};

const jobPostsReducer = handleActions(
  {
    [setJobPost as any]: (state, action) => {
      return { ...state, userJobPosts: [...state.userJobPosts, action.payload] };
    },
    [setUserJobPosts as any]: (state, action: any) => {
      return { ...state, userJobPosts: [...action.payload] };
    },
    [removeRecruiterCandidate as any]: (state, action: any) => ({
      ...state,
      userJobPosts: state.userJobPosts.map((job: any) => {
        if (job.id === action.payload.jobId) {
          return { ...job, candidateCount: job.candidateCount - 1 };
        }
        return job;
      }),
    }),
    [setAllJobPosts as any]: (state, action: any) => {
      return { ...state, allJobPosts: [...action.payload] };
    },
    [saveRecruiterJobPost as any]: (state, action: any) => {
      return {
        ...state,
        allJobPosts: state.allJobPosts.map((jobPost: any) => {
          if (jobPost.id === action.payload.jobPostId) {
            return { ...jobPost, saved: true };
          }
          return jobPost;
        }),
        userJobPosts: [
          ...state.userJobPosts,
          {
            ...state.allJobPosts.find((jobPost: any) => jobPost.id === action.payload.jobPostId),
            saved: true,
          },
        ],
      };
    },
    [deleteRecruiterJobPost as any]: (state, action: any) => {
      return {
        ...state,
        allJobPosts: state.allJobPosts.map((jobPost: any) => {
          if (jobPost.id === action.payload.jobPostId) {
            return { ...jobPost, saved: false };
          }
          return jobPost;
        }),
        /* eslint-disable */
        userJobPosts: state.userJobPosts.filter(
          (jobPost: any) => jobPost.id !== action.payload.jobPostId
        ),
      };
    },
    [setJobPostsLoading as any]: (state, { payload }: Action<any>) => ({
      ...state,
      loading: payload,
    }),
  },
  jobPostsInitialState
);

export default jobPostsReducer;
